import React from "react";
import { isSet } from "../../../../../../utils/commonUtils";
import FormInputs from "../../../../../../components/UI/FormInputs";

const NewYesOrNo = ({
    showNotes,
    notes,
    options = [{ label: 'Yes', value: 'Yes' }, { label: 'No', value: 'No' }, { label: 'Not Sure', value: 'Not Sure' }],
    col,
    failedValue,
    list,
    label,
    appendClass,
    readOnly,
    validation,
    formData,
    changeHandler,
    defaultValues,
    defaultBtnLabel,
    ...props
}) => {

    // Function to handle bulk update (Header controls)
        const handleBulkUpdate = (value) => {
            if (readOnly) return;
            
            const updatedData = {};
            list.forEach(item => {
                updatedData[item.name] = value;
            });
            props.updateFormData(updatedData);
        };
        const isAllSelected = (value) => {
            if (!list || list.length === 0) return false;
            return list.every((item) => {
                const itemValue = isSet(formData[item.name], '');
                return itemValue === value;
            });
        };
    
    const isAllNegative = list && list.length > 0 && list.every((item) => {
        const currentValue = isSet(formData[item.name], '');
        const targetDefault = defaultValues && defaultValues[item.name];
        return currentValue === targetDefault;
    });

    // 2. Toggle Action
    const toggleAllNegative = () => {
        if (readOnly) return;

        let updatedData = {};
        
        if (isAllNegative) {
            // If already all negative, clear them (or set to empty)
            list.forEach(item => {
                updatedData[item.name] = ''; 
            });
        } else {
            // If not all negative, apply the mapping from defaultValues
            updatedData = { ...defaultValues };
        }
        
        // Use the updateFormData function passed via props
        props.updateFormData(updatedData);
    };

    return (
        <div className={`card sh_basecard border-0 shadow-none h-auto mb-0 ${appendClass}`}>
            <div className="card-header sh_basecardHeader">
                <div className="row align-items-center">
                    <div className="col-12 col-md-4">
                        <h6 className="m-0 text-md font-weight-bold">
                            {label}
                        </h6>
                    </div>
                    
                    {/* Header Bulk Controls (Yes/No/Not Sure) */}
                    <div className="col-12 col-md-8 exam-dot-resposive-radio-group gap-1 d-flex justify-content-end align-items-start">
                         <div className=" d-flex align-items-center gap-2">
                        <span className="form-check-label cursor-pointer" >
                            {defaultBtnLabel}
                        </span>
                            <div>
                                <a className="cursor-pointer" title="Set All Negative">
                                   <span className="d-flex align-items-center">
                                        <label className="switch mb-0">
                                             <FormInputs
                                                   className="form-check-input"
                                                   type="Checkbox"
                                                   name="activationstatus"
                                                   id="activationstatus"
                                                   value={isAllNegative}
                                                   changeHandler={toggleAllNegative}
                                            />
                                           <span className="slider round"></span>
                                       </label>
                                    </span>
                                </a>
                            </div>
                    </div>
                        {options.map((opt, index) => (
                            <div className="form-check d-flex form-check-inline" key={`header_${index}`}>
                               
                                <input 
                                    className="form-check-input cursor-pointer" 
                                    type="radio" 
                                    name={`bulk_update_${label.replace(/\s/g, '')}`} // Unique group name for header
                                    id={`header_opt_${index}_${label.replace(/\s/g, '')}`}
                                    disabled={readOnly}
                                    onChange={() => handleBulkUpdate(opt.value)}
                                    checked={isAllSelected(opt.value)}
                                   
                                />
                                <label 
                                    className="form-check-label cursor-pointer" 
                                    htmlFor={`header_opt_${index}_${label.replace(/\s/g, '')}`}
                                >
                                    {opt.label}
                                </label>
                            </div>
                        ))}
                    </div>
                    </div>
            </div>

            {/* --- Card Body --- */}
            <div className="card-body p-2 sh_basecardBody">
                <div className="row">
                    <div className="col-md-12">
                        {list.map((tData, tIndex) => {
                            const hasError = isSet(validation) && isSet(validation[tData.name], "") !== "";
                            
                            return (
                                <div key={tIndex} className="">
                                    <div className="form-group row mb-0 align-items-center">
                                        {/* Question Label */}
                                        <div className="col-12 exam-dot-resposive-label col-md-6">
                                            <label className="form-label mb-2 pb-2">
                                                {tData.label}
                                                {/* Validation Error Message */}
                                                {hasError && (
                                                    <span className="text-danger ml-2 small">
                                                        ({validation[tData.name]})
                                                    </span>
                                                )}
                                            </label>
                                        </div>

                                        {/* Radio Options */}
                                        <div className="col-12 col-md-6 exam-dot-resposive-radio-group d-flex justify-content-end">
                                            {options.map((option, optionIndex) => {
                                                const isSelected = (isSet(formData[tData.name], null) === option.value);
                                                
                                                // Handle failed/abnormal value styling (Red background)
                                                let inputStyle = {};
                                                const activeFailedValue = isSet(tData.failedValue) ? tData.failedValue : failedValue;
                                                
                                                if (isSet(activeFailedValue, null) !== null && 
                                                    activeFailedValue.indexOf(option.value) >= 0 && 
                                                    formData[tData.name] === option.value) {
                                                    inputStyle = { backgroundColor: 'red', borderColor: 'red' };
                                                }

                                                return (
                                                    <div className="form-check form-check-inline" key={optionIndex}>
                                                        {/* Using FormInputs to maintain existing logic hooks, but styled as requested */}
                                                        <FormInputs
                                                            className="form-check-input"
                                                            type='Radio'
                                                            style={{ ...inputStyle }}
                                                            name={`${tData.name}_${tIndex}`} // Group per question
                                                            id={`radio_${tData.name}_${tIndex}_${optionIndex}`}
                                                            value={isSelected} // FormInputs expects bool for 'checked' logic in some versions, or value match
                                                            readOnly={readOnly}
                                                            onKeyPress={tData.onKeyPress}
                                                            changeHandler={() => changeHandler(tData.name, option.value)}
                                                        />
                                                        {/* The invisible label keeps layout spacing consistent with the HTML provided */}
                                                        <label 
                                                            className="form-check-label visible-sm  invisible-sm"
                                                            htmlFor={`radio_${tData.name}_${tIndex}_${optionIndex}`}
                                                        >
                                                            {option.label}
                                                        </label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    {/* Optional Notes Field (If enabled) */}
                                    {showNotes && (
                                        <div className="row mt-1">
                                            <div className="col-md-12">
                                                <FormInputs
                                                    type="TextArea"
                                                    className="form-control form-control-sm"
                                                    name={tData.notesName || `${tData.name}_notes`}
                                                    id={tData.notesName || `${tData.name}_notes`}
                                                    value={formData[tData.notesName || `${tData.name}_notes`] || ""}
                                                    changeHandler={(value) => changeHandler(tData.notesName || `${tData.name}_notes`, value)}
                                                    readOnly={readOnly}
                                                    placeholder="Add details/notes..."
                                                    rows="2"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

NewYesOrNo.defaultProps = {
    appendClass: 'mt-3',
    failedValue: null,
    validation: {},
    showNotes: false
};

export default NewYesOrNo;